import cn from "@utils/cn";

const CLASS_NAMES = cn(`
  flex
  max-h-[calc(90vh_-_120px)]
  flex-col
  gap-5
  overflow-y-auto
  bg-white
  p-5
`);

export default function ModalBody(props) {
  return (
    <section className={CLASS_NAMES}>
      {props.children}
    </section>
  );
}
